import { FlightConfigurationDto } from "../../flightConfiguration/flightConfiguration.dto";
import { WeatherCode } from "../../summary/weather.code";
import { WeatherListItemDto } from "../weatherListItem.dto";
import { FlightStatusCode } from "./flightStatus.code";

export class WeatherListDto {
    public date!: string;
    public sunrise!: string;
    public sunset!: string;
    public isVisible: boolean = true;
    public isPossibleToFly: boolean = true;
    public infos: WeatherListItemDto[] = [];
    public maxWindSpeed!: number;

    public getMaximumTemperature(): number {
        let maximumTemperature: number = -9999;
        
        for (let i = 0; i < this.infos.length; i++) {
            if (this.infos[i].data.temperature > maximumTemperature) {
                maximumTemperature = this.infos[i].data.temperature;
            }
        }

        return maximumTemperature;
    }

    public getMinimumTemperature(): number {
        let minimumTemperature: number = 9999;
        
        for (let i = 0; i < this.infos.length; i++) {
            if (this.infos[i].data.temperature < minimumTemperature) {
                minimumTemperature = this.infos[i].data.temperature;
            }
        }

        return minimumTemperature;
    }

    public getAverageWindSpeed(): number {
        for (let i = 0; i < this.infos.length; i++) {
            if (this.sunrise <= this.infos[i].timeTag) {
                return this.infos[i].data.windSpeed;
            }
        }

        return 0;
    }

    public setMaxWindSpeed(): void {
        this.maxWindSpeed = -9999;

        for (let i = 0; i < this.infos.length; i++) {
            if (this.infos[i].data.windSpeed > this.maxWindSpeed) {
                this.maxWindSpeed = this.infos[i].data.windSpeed;
            }
        }
    }

    public getWeatherCode(): WeatherCode {
        for (let i = 0; i < this.infos.length; i++) {
            if (this.sunrise <= this.infos[i].timeTag) {
                if (this.infos[i].data.ptype == 1) {
                    return WeatherCode.RAINY;
                }
    
                if (this.infos[i].data.ptype == 5 || this.infos[i].data.ptype == 6) {
                    return WeatherCode.SNOWY;
                }

                return WeatherCode.SUNNY
            }
        }

        return WeatherCode.SUNNY
    }

    public isPossibleFlight(flightConfigurationDto: FlightConfigurationDto, isContainedGust: boolean): FlightStatusCode {
        let resultStatus: FlightStatusCode = FlightStatusCode.GOOD;

        for (let i = 0; i < this.infos.length; i++) {
            if (this.sunrise <= this.infos[i].timeTag) {
                return this.infos[i].isPossibleFlight(flightConfigurationDto, isContainedGust);
            }
        }

        return resultStatus;
    }
    
    public isPossibleFlightWithSatellite(flightConfigurationDto: FlightConfigurationDto, satelliteCount: number, isContainedGust: boolean): FlightStatusCode {
        for (let i = 0; i < this.infos.length; i++) {
            if (this.sunrise <= this.infos[i].timeTag) {
                let status: FlightStatusCode = this.infos[i].isPossibleFlight(flightConfigurationDto, isContainedGust);
            
                if (status == FlightStatusCode.DANGER) {
                    return status;
                }

                if (satelliteCount < flightConfigurationDto.satelliteCount) {
                    return FlightStatusCode.DANGER;
                }
        
                return status;
            }
        }

        return FlightStatusCode.GOOD;
    }
}